//#region import
import React from "react";
import { Grid } from "@mui/material";
import { useLocation } from "react-router";
import { I18n } from "utilities/utilities";
import Tabs, { TabContent, TabItem, TabPanel } from "components/Input/Tab";
import MaterialInventoryTabel from "./MaterialInventoryTabel";
import { EditNote, PostAdd, RestorePage } from "@mui/icons-material";
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
//#endregion

export default function MaterialInventoryList() {
  const location = useLocation();
  const searchParams = location.search;
  const sMode = new URLSearchParams(searchParams).get("sMode");

  return (
    <>
      <Grid container spacing={2}>
        <Grid item marginTop={"10px"} xs={12}>
          <Tabs id={"MaterialInventory"} defaultTab={!sMode ? "Receive" : sMode}>
            <TabItem id="Receive"><AddShoppingCartIcon className="vertical-middle"/>{" "}{"การรับวัสดุ"}</TabItem>
            <TabItem id="Withdraw"><PostAdd className="vertical-middle"/>{" "}{"การเบิกจ่ายวัสดุ"}</TabItem>
            <TabItem id="WithdrawType2"><EditNote className="vertical-middle"/>{" "}{"บันทึกการยืมวัสดุ"}</TabItem>
            <TabItem id="Return"><RestorePage className="vertical-middle"/>{" "}{"บันทึกการคืนวัสดุ"}</TabItem>
            <TabContent id={"MaterialInventoryTabContent"}>
              <TabPanel id="Receive">
                <MaterialInventoryTabel sMode="Receive" />
              </TabPanel>
              <TabPanel id="Withdraw">
                <MaterialInventoryTabel sMode="Withdraw" />
              </TabPanel>
              <TabPanel id="WithdrawType2">
                <MaterialInventoryTabel sMode="WithdrawType2" />
              </TabPanel>
              <TabPanel id="Return">
                <MaterialInventoryTabel sMode="Return" />
              </TabPanel>
            </TabContent>
          </Tabs>
        </Grid>
      </Grid>
    </>
  );
}
